// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_t1-0";
export var checkoutRateBadgeLink = "_t1-1";